import * as React from 'react';
import TextField from '@mui/material/TextField';
import { IconButton, InputAdornment, Snackbar } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { loader } from '../../Func_genericas/loader';
import { imagens } from '../../Func_genericas/valores_estaticos';
import { get_token, registar_organizacao } from '../../Hook/useApi';
import { Alert } from '../../Components/Alert/Alert';
import { func_print } from '../../Func_genericas/func_print';
import { post_login } from '../../Services/tokenConfig';
import { Preenchercodigo } from './Preenchercodigo';

// bordas outlined mais suaves (estado normal / hover; foco mantém cor da marca)
const loginTextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    '& fieldset': {
      borderColor: 'rgba(15, 23, 42, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(15, 23, 42, 0.16)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#c94f1e',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#c94f1e',
  },
};

export default function SignInSide() {



  const [form_mode, set_form_mode] = React.useState<'login' | 'registo'>('login');
  const [msg_aviso, set_msg_aviso] = React.useState<string>('');
  const [msg_sucesso, set_msg_sucesso] = React.useState<string>('');
  const [username, set_username] = React.useState<string>('');
  const [password, set_password] = React.useState<string | undefined>('');
  const [nome_responsavel, set_nome_responsavel] = React.useState<string>('');
  const [nif, set_nif] = React.useState<string>('');
  const [contacto_telefonico, set_contacto_telefonico] = React.useState<string>('');

  const [open_modal_aviso, set_open_modal_aviso] = React.useState<boolean>(false);
  const [open_modal_sucesso, set_open_modal_sucesso] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [open_code_insert, set_open_code_insert] = React.useState<boolean>(false);
  const [open_modal_recuperar_password, set_open_modal_recuperar_password] =
    React.useState<boolean>(false);
  const [mostrar_password, set_mostrar_password] = React.useState(false);

  const submitLogin = async () => {
    setIsLoading(true);
    try {
      if (username !== undefined && password !== undefined) {
        const aux_obj = {
          email: username === undefined ? '' : username,
          password: password === undefined ? '' : password,
          secret_2fa: null,
        };

        const res: any = await get_token({ payload: aux_obj });

        if (res.flag === false) {
          set_msg_aviso(res.error);
          set_open_modal_aviso(true);
        } else {
          set_open_code_insert(true);
        }
      }
      setIsLoading(false);
    } catch (error: any) {
      set_msg_aviso(error);
      set_open_modal_aviso(true);
      setIsLoading(false);
    }
  };

  const submitRegisto = async () => {
    const nif_limpo = nif.replace(/\D/g, '');
    const contacto_limpo = contacto_telefonico.replace(/\D/g, '');

    if (
      nome_responsavel.trim().length === 0 ||
      nif_limpo.length === 0 ||
      contacto_limpo.length === 0
    ) {
      set_msg_aviso('Preencha todos os campos obrigatórios.');
      set_open_modal_aviso(true);
      return;
    }

    if (nif_limpo.length !== 9) {
      set_msg_aviso('NIF inválido. Deve ter 9 dígitos.');
      set_open_modal_aviso(true);
      return;
    }

    if (contacto_limpo.length < 9) {
      set_msg_aviso('Contacto telefónico inválido.');
      set_open_modal_aviso(true);
      return;
    }

    setIsLoading(true);
    try {
      const res: any = await registar_organizacao({
        nome_responsavel: nome_responsavel.trim(),
        nif: nif_limpo,
        contacto_telefonico: contacto_limpo,
      });

      if (res.flag === false) {
        set_msg_aviso(res.error ?? 'Erro ao efetuar a sua operação!');
        set_open_modal_aviso(true);
      } else {
        set_nome_responsavel('');
        set_nif('');
        set_contacto_telefonico('');
        set_form_mode('login');
        set_msg_sucesso('Registo submetido com sucesso.');
        set_open_modal_sucesso(true);
      }
    } catch (error) {
      func_print('submitRegisto', error, true);
      set_msg_aviso('Erro ao efetuar a sua operação!');
      set_open_modal_aviso(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handle_recuperar_password = async () => {
    try {
      setIsLoading(true);
      const data = await post_login('', 'reset_password', {
        payload: {
          email: username,
          secret_2fa: null,
        },
      });
      if (data.status === 200) {
        set_password(undefined);
        set_open_code_insert(true);
        set_open_modal_recuperar_password(false);
      } else {
        set_msg_aviso('Erro ao efetuar a sua operação!');
        set_open_modal_aviso(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print('handle_recuperar_password', error, true);
      setIsLoading(false);
      set_msg_aviso('Erro ao efetuar a sua operação!');
      set_open_modal_aviso(true);
    }
  };

  if (open_code_insert) {
    return (
      <Preenchercodigo
        set_open_code_insert={set_open_code_insert}
        email={username}
        password={password}
      />
    );
  }

  if (isLoading) return loader();



  return (
    <>
      <Snackbar
        open={open_modal_aviso}
        autoHideDuration={2000}
        onClose={() => set_open_modal_aviso(false)}
      >
        <Alert onClose={() => set_open_modal_aviso(false)} severity="error" sx={{ width: '100%' }}>
          {msg_aviso}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open_modal_sucesso}
        autoHideDuration={2500}
        onClose={() => set_open_modal_sucesso(false)}
      >
        <Alert onClose={() => set_open_modal_sucesso(false)} severity="success" sx={{ width: '100%' }}>
          {msg_sucesso}
        </Alert>
      </Snackbar>

      {open_modal_recuperar_password && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl bg-white p-8 shadow-sm">
            <button
              type="button"
              onClick={() => set_open_modal_recuperar_password(false)}
              className="absolute right-4 top-4 p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
            <h3 className="mb-2 text-xl font-bold text-gray-800">Recuperar palavra-passe</h3>
            <p className="mb-2 text-sm text-gray-500">
              Insira o seu email para receber um código de recuperação.
            </p>
            <p className="mb-4 text-xs text-gray-400">
              Irá ser enviado um código de recuperação de palavra-passe para o email inserido.
            </p>
            <TextField
              variant="outlined"
              fullWidth
              type="email"
              label="Email"
              placeholder="O seu email"
              value={username}
              onChange={(e) => set_username(e.target.value)}
              margin="normal"
              sx={loginTextFieldSx}
            />
            <button
              type="button"
              onClick={handle_recuperar_password}
              className="mt-5 w-full inline-flex items-center justify-center px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer shadow-none"
            >
              Recuperar palavra-passe
            </button>
          </div>
        </div>
      )}

      <div className="grid h-[100dvh] w-full min-w-0 grid-cols-1 overflow-hidden md:grid-cols-2">
        <div className="hidden min-h-0 min-w-0 flex-col items-center justify-center bg-[#C94F1E] px-12 py-8 md:flex md:px-20 md:py-10 lg:px-24">
          <div className="flex w-full max-w-lg flex-col items-center gap-10 text-center">
            <div className="min-w-0">
              <h1 className="text-6xl font-extrabold tracking-tight text-white">VULPES</h1>
              <p className="mt-4 text-sm leading-relaxed text-white">
                Inteligente e versátil, Vulpes fornece ferramentas de gestão das suas atividades agrícolas,
                otimização de recursos, permitindo tomar as melhores decisões estratégicas obtendo uma
                produção agrícola eficiente e sustentável.
              </p>
            </div>
            <div className="flex flex-col items-center gap-4">
              <img
                src={imagens.logo_login}
                alt="Vulpes logo"
                className="w-48 opacity-90 drop-shadow-xl"
              />
              <button
                type="button"
                onClick={() => window.open('https://2gfinnovationsystems.pt/')}
                className="bg-transparent border-none text-xs text-white/60 underline underline-offset-2 hover:text-white/90 transition-colors cursor-pointer"
              >
                Desenvolvido por 2GF Innovation Systems
              </button>
            </div>
          </div>
        </div>

        <div className="flex min-h-0 min-w-0 flex-col items-center justify-center bg-white p-8 md:p-10">
          <div className="mb-8 flex flex-col items-center md:hidden">
            <h1 className="text-4xl font-extrabold text-[#C94F1E]">Vulpes</h1>
          </div>

          <div className="w-full max-w-sm min-h-[560px]">
            <h2 className="mb-4 text-3xl font-bold text-gray-800">
              {form_mode === 'login' ? 'Bem-vindo!' : 'Registar organização'}
            </h2>
            <div className="mb-5 flex gap-1 rounded-xl bg-neutral-100 p-1">
              <button
                type="button"
                onClick={() => set_form_mode('login')}
                className={`relative flex-1 rounded-[10px] px-3 py-2 text-sm font-semibold border-0 cursor-pointer transition-all duration-300 ease-[cubic-bezier(0.33,1,0.68,1)] ${
                  form_mode === 'login'
                    ? 'bg-white text-[#c94f1e]'
                    : 'bg-transparent text-neutral-500 hover:text-neutral-700'
                }`}
              >
                Login
              </button>
              <button
                type="button"
                onClick={() => set_form_mode('registo')}
                className={`relative flex-1 rounded-[10px] px-3 py-2 text-sm font-semibold border-0 cursor-pointer transition-all duration-300 ease-[cubic-bezier(0.33,1,0.68,1)] ${
                  form_mode === 'registo'
                    ? 'bg-white text-[#c94f1e]'
                    : 'bg-transparent text-neutral-500 hover:text-neutral-700'
                }`}
              >
                Registo
              </button>
            </div>

            <div className="relative min-h-[350px]">
              <div
                className={`absolute inset-0 transition-all duration-300 ease-in-out ${
                  form_mode === 'login'
                    ? 'translate-x-0 opacity-100 pointer-events-auto'
                    : '-translate-x-2 opacity-0 pointer-events-none'
                }`}
              >
                <div className="flex flex-col gap-0">
                  <TextField
                    variant="outlined"
                    fullWidth
                    type="email"
                    label="Email"
                    placeholder="email@exemplo.pt"
                    value={username}
                    onChange={(e) => set_username(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && submitLogin()}
                    margin="normal"
                    sx={loginTextFieldSx}
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    type={mostrar_password ? 'text' : 'password'}
                    label="Palavra-passe"
                    placeholder="••••••••"
                    value={password ?? ''}
                    onChange={(e) => set_password(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && submitLogin()}
                    margin="normal"
                    sx={loginTextFieldSx}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            aria-label={mostrar_password ? 'ocultar palavra-passe' : 'mostrar palavra-passe'}
                            onClick={() => set_mostrar_password((v) => !v)}
                            edge="end"
                          >
                            {mostrar_password ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div className="mt-3 flex justify-end">
                  <button
                    type="button"
                    onClick={() => set_open_modal_recuperar_password(true)}
                    className="text-xs text-[#C94F1E] hover:underline bg-transparent border-none cursor-pointer"
                  >
                    Esqueceu-se da palavra-passe?
                  </button>
                </div>

                <button
                  type="button"
                  onClick={submitLogin}
                  className="mt-6 w-full inline-flex items-center justify-center px-5 py-4 rounded-xl font-bold text-lg text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer shadow-none"
                >
                  Iniciar Sessão
                </button>
              </div>

              <div
                className={`absolute inset-0 transition-all duration-300 ease-in-out ${
                  form_mode === 'registo'
                    ? 'translate-x-0 opacity-100 pointer-events-auto'
                    : 'translate-x-2 opacity-0 pointer-events-none'
                }`}
              >
                <div className="flex flex-col gap-0">
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Nome do responsável"
                    placeholder="Nome completo"
                    value={nome_responsavel}
                    onChange={(e) => set_nome_responsavel(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && submitRegisto()}
                    margin="normal"
                    sx={loginTextFieldSx}
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="NIF"
                    placeholder="999999999"
                    value={nif}
                    onChange={(e) => set_nif(e.target.value.replace(/\D/g, ''))}
                    onKeyDown={(e) => e.key === 'Enter' && submitRegisto()}
                    margin="normal"
                    sx={loginTextFieldSx}
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Contacto telefónico"
                    placeholder="912345678"
                    value={contacto_telefonico}
                    onChange={(e) => set_contacto_telefonico(e.target.value.replace(/\D/g, ''))}
                    onKeyDown={(e) => e.key === 'Enter' && submitRegisto()}
                    margin="normal"
                    sx={loginTextFieldSx}
                  />
                </div>
                <button
                  type="button"
                  onClick={submitRegisto}
                  className="mt-6 w-full inline-flex items-center justify-center px-5 py-4 rounded-xl font-bold text-lg text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer shadow-none"
                >
                  Registar Organização
                </button>
              </div>
            </div>

            <p className="mt-6 text-center text-xs leading-relaxed text-gray-400">
              Ao iniciar sessão declara que concorda com as nossas{' '}
              <a
                href="https://2gfinnovationsystems.pt/politica-privacidade.html"
                target="_blank"
                rel="noopener noreferrer"
                className="font-normal text-gray-400 underline underline-offset-2"
              >
                Política de Privacidade
              </a>
              {' '}e{' '}
              <a
                href="https://2gfinnovationsystems.pt/politica-cookies.html"
                target="_blank"
                rel="noopener noreferrer"
                className="font-normal text-gray-400 underline underline-offset-2"
              >
                Política de Cookies
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
